// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4e7afd45","455":"45aab556","977":"1d33c50d"}[chunkId] + ".chunk.js";
};